var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "tool-box" },
        [
          _c("el-button", { on: { click: _vm.btnAdd } }, [_vm._v("添加")]),
          _c(
            "el-button",
            {
              attrs: { type: "danger", plain: "" },
              on: { click: _vm.btnRemoveAll },
            },
            [_vm._v("清空")]
          ),
        ],
        1
      ),
      _c(
        "MutipleSelect",
        { on: { remove: _vm.selectRemove } },
        _vm._l(_vm.menuList, function (item, index) {
          return _c("MutipleSelectOption", {
            key: index,
            attrs: { label: item.functionName, value: item.functionCode },
          })
        }),
        1
      ),
      _c("ModalPage", {
        ref: "ModalPage",
        on: { onGetSelect: _vm.dialog_btnConfirm },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }